import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { LoadingSpinner } from '@parkhub/parkhub-ui';
import { OverviewDialog, Table, DeactivateModal } from '../../components';
import { getOrganizations, deactivateOrg } from '../../actions/organizations.action';
import { clearAllFilters } from '../../actions/filter.action';

const organizationsListLabelKeys = [
  { label: 'Child Organization', key: 'childName', sortable: true },
  { label: 'Relationship', key: 'relationshipType', sortable: true },
  { label: 'Parent Organization', key: 'parentName', sortable: true },
  { label: 'Landmark', key: 'landmarkName', sortable: true }
];

class Organizations extends Component {
  state = {
    tableData: []
  }

  componentDidMount() {
    this.props.clearAllFilters();
    this.props.getOrganizations();
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({ tableData: this.props.organizations });
    }
  }

  componentWillUnmount() {
    this.props.actions.hide();
  }

  render() {
    const { actions, dialogVisible, dialogTitle, dialogContent, relationships, filteredData, isLoading, deactivateOrg } = this.props;
    const orgActions = {
      hide: actions.hide,
      show: actions.show,
      hideDisable: actions.hideDisable,
      showDisable: actions.showDisable,
      deactivateOrg
    };

    return (
      <Fragment>
        <div>
          <Table
            title="Organizations"
            labelKeys={organizationsListLabelKeys}
            data={!!filteredData ? filteredData : relationships}
            actions={orgActions}
            isLoading={isLoading}
          />
        </div>
        <OverviewDialog
          visible={dialogVisible}
          onHide={orgActions.hide}
          data={dialogContent}
          title={dialogTitle}
        />
        <DeactivateModal
          visible={this.props.disableModalVisible}
          onHide={orgActions.hideDisable}
        />
        <LoadingSpinner show={this.props.isLoading} delay={650} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  organizations: state.organizations.data,
  dialogVisible: state.wizard.visible,
  dialogContent: state.wizard.data,
  dialogTitle: state.wizard.title,
  relationships: state.organizations.relationships,
  filteredData: state.filter.orgFilteredData,
  isLoading: state.organizations.isLoading,
  disableModalVisible: state.dialog.visible
});

export default connect(mapStateToProps, {
  clearAllFilters,
  getOrganizations,
  deactivateOrg
})(Organizations);



// WEBPACK FOOTER //
// ./src/containers/Organizations/Organizations.jsx